import {
  QuickPassProfile,
  QuickPassStreakState,
  QuickPassUnitPreferences,
} from '../_types/quickpass-profile'

const defaultQuickPassUnitPreferences: QuickPassUnitPreferences = {
  priceMin: null,
  priceMax: null,
  bedroomCounts: [],
  bathroomCounts: [],
  propertyTypes: [],
  dwellingScope: 'no-preference',
  cities: [],
  preferredMoveInDate: null,
}

const defaultQuickPassStreakState: QuickPassStreakState = {
  currentStreakDays: 0,
  longestStreakDays: 0,
  lastVisitDateString: '',
}

const defaultQuickPassProfile: QuickPassProfile = {
  id: '',
  quickPassUserId: '',
  firstName: '',
  lastName: '',
  unitPreferences: defaultQuickPassUnitPreferences,
  savedListingIds: [],
  savedListingHosts: {},
  inquiriesSentLeadIds: [],
  quizResults: [],
  unlockedAchievementIds: [],
  listingTags: {},
  listingNotes: {},
  archivedListingIds: [],
  listingCollections: {},
  movePrepCompletions: {},
  streakState: defaultQuickPassStreakState,
  monthlyTakeHomeIncome: null,
  digestFrequency: 'weekly',
  lastDigestSentAt: null,
  recentlyViewedDiscoverIds: [],
  applicationParagraphs: null,
  verifications: [],
  onboardingCompletedAt: null,
  createdAt: 0,
  updatedAt: 0,
}

export {
  defaultQuickPassUnitPreferences,
  defaultQuickPassStreakState,
  defaultQuickPassProfile,
}
